import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-kyc-upload',
  templateUrl: './kyc-upload.component.html',
  styleUrls: ['./kyc-upload.component.css']
})
export class KycUploadComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
